import { PopperContent } from '@/components/poppers/PopperContent';

export function SubtrustCreatedFromHelp() {
  return (
    <PopperContent body="Identify the main trust that creates this sub-trust and determines how it is administered" />
  );
}
